import Service from 'additiv-services';
import { getQueryStringByObject } from 'additiv-services/utils/queryUtils';
import { getCustomServiceLayerHeader } from 'additiv-services/setup';
import {
    CUSTOM_SERVICE_LAYER_SERVICES,
    getCustomServiceLayerBaseUrl,
} from '../constants';

class CustomService extends Service {
    static #baseServiceUrl = getCustomServiceLayerBaseUrl(
        CUSTOM_SERVICE_LAYER_SERVICES.DEFAULT,
    );

    static getClientNotes({ contactId, pageSize, pageNumber }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}contactNote/GetContactNotes?contactId=${contactId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static saveClientNote(payload) {
        return Service.postRequest(
            `${this.#baseServiceUrl}contactNote/InsertContactNote`,
            payload,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static searchPbNumbers({ filter }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}lookup/pbnumbers?filter=${filter}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static searchRestrictedPbNumbers({ filter }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}lookup/pbnumbers/search?filter=${filter}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static getOccupationsLookup(params) {
        const queryString = getQueryStringByObject(params);

        return Service.getRequest(
            `${this.#baseServiceUrl}lookup/occupations?${queryString}`,
            {
                isSecure: true,
                cache: false,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static heartBeat({ identifier }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}heart-beat?guidIdentifier=${identifier}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }

    static validateIban({ iban }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}validateIban?iban=${iban}`,
            { isSecure: true, axiosSetup: { headers: getCustomServiceLayerHeader() } },
        );
    }
}
export default CustomService;
